import axios from "axios";

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const API_URL = `${API_ROOT}/components`;

// Attach JWT if present
function getAuthHeaders() {
	const token = localStorage.getItem('jwt');
	return token ? { Authorization: `Bearer ${token}` } : {};
}

// Global axios interceptor for 401 errors
axios.interceptors.response.use(
	response => response,
	error => {
		if (error.response && error.response.status === 401) {
			const req = error.config;
			// Only logout/reload if not a public GET to /api/components
			const isPublicGet = req && req.method === 'get' && req.url &&
				(req.url.endsWith('/api/components') || req.url.match(/\/api\/components\/[^/]+$/));
			if (!isPublicGet) {
				localStorage.removeItem('jwt');
				window.location.reload();
			}
		}
		return Promise.reject(error);
	}
);

export const getAllComponents = () => axios.get(API_URL, { headers: getAuthHeaders() });
export const getComponentById = (id) => axios.get(`${API_URL}/${id}`, { headers: getAuthHeaders() });
export const createComponent = (data) => axios.post(API_URL, data, { headers: getAuthHeaders() });
export const updateComponent = (id, data) => axios.put(`${API_URL}/${id}`, data, { headers: getAuthHeaders() });
export const deleteComponent = (id) => axios.delete(`${API_URL}/${id}`, { headers: getAuthHeaders() });
export const getComponentsByCategory = (category) => axios.get(`${API_URL}?category=${encodeURIComponent(category)}`, { headers: getAuthHeaders() });
export const publishComponent = (id) => axios.post(`${API_URL}/${id}/publish`, {}, { headers: getAuthHeaders() });